import { useCallback, useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useAddOns, useAuth } from '@/store';
import { useModals } from '@mattjennings/react-modal-stack';
import { setPromotionError, restoreError } from '@/store/promotions/promotions.slice';
import RemoveProtectionDialog from './RemoveProtectionDialog';
import RemoveProtectionDialogByFailure from './RemoveProtecionDialogByFailure';

export default function useAddOnsControl() {
  const promotions = useSelector((state) => state.promotions, shallowEqual);
  const { total_to_pay: totalToPay } = useSelector(
    (state) => state.summary,
    shallowEqual,
  );

  console.log(promotions)

  const { isSeller } = useAuth();

  const dispatch = useDispatch();

  const {
    ticketInsurance,
    addOnsActive,
    addTicketInsurance,
    removeTicketInsurance,
    disableTicketInsurance,
    eneableTicketInsurance,
    setTicketInsuranceNotHealthy,
    setTicketInsurancePrice,
  } = useAddOns();

  const { openModal } = useModals();

  const openDialog = () => {
    setTimeout(() => {
      openModal(RemoveProtectionDialog);
    }, 100);
  };

  const openFailDialog = () => {
    setTimeout(() => {
      openModal(RemoveProtectionDialogByFailure);
    }, 100);
  };

  const handleTicketInsuranceHealthy = (path = 'payment') => {
    setTicketInsuranceNotHealthy();
    if (path === 'addons') openFailDialog();
    if (path === 'payment') openDialog();
  };

  const verifyHealthy = (data, path) => {
    if (!data?.addon_available) return true;

    const ticketInsuranceData = data.addon_available.find(
      (e) => e.kind === 'ticket_insurance',
    );
    if (!ticketInsurance) return true;
    const { healthy } = ticketInsuranceData;

    if (!healthy) {
      handleTicketInsuranceHealthy(path);
      return false;
    }
    return true;
  };

  const verifyData = useCallback((data, path) => {
    if (!verifyHealthy(data, path)) {
      return;
    }

    let isFreeBooking = data?.total_to_pay <= 0;

    const { selected } = ticketInsurance;

    if (isFreeBooking) {
      dispatch(setPromotionError('total_zero'))
    } else if (promotions?.error === 'total_zero') {
      dispatch(restoreError())
    }

    const isInPath = path.includes('addons') || path.includes('payment');

    if (
      path.includes('payment') &&
      isFreeBooking &&
      !promotions.error &&
      !selected
    ) {
      return data;
    }

    if (isFreeBooking && !promotions?.error && isInPath) {
      openDialog();
      return data;
    }

    return data;
  }, [promotions]);

  const handleTicketInsurancePrice = (data) => {
    if (data && data.addon_available) {
      const ticketInsuranceData = data.addon_available.find(
        (e) => e.kind === 'ticket_insurance',
      );
      if (ticketInsuranceData) {
        setTicketInsurancePrice(ticketInsuranceData.price);
      }
    }
  };

  const toggleTicketInsurance = (checked) => {
    if (totalToPay <= 0) {
      return;
    }
    if (checked) {
      addTicketInsurance();
    } else {
      removeTicketInsurance();
    }
  };

  useEffect(() => {

    if ((promotions?.error === 'total_zero' || isSeller) && addOnsActive) {
      disableTicketInsurance();
    }

    if (!promotions?.error && !addOnsActive) {
      eneableTicketInsurance()
    }
  }, [promotions, isSeller]);

  return {
    ticketInsurancePrice: ticketInsurance.price,
    toggleTicketInsurance,
    handleTicketInsurancePrice,
    handleTicketInsuranceHealthy,
    verifyData,
  };
}
